module.exports = __webpack_public_path__ + "static/media/evaporator.d8393871.png";